<template>
    <el-dialog
        title="分享"
        :visible.sync="shareDialog"
        width="520px"
        :before-close="handleDialogClose"
        :close-on-click-modal="false"
        custom-class="custom-share-dialog"
    >
        <div class="custom-share-dialog-wrap">
            <div class="box" id="qrcodeOutBox">
                <CustomerCompanyCard
                    ref="customerCompanyCard"
                    :customer_id="shareCustomerId"
                    :customerName="shareCustomerName"
                    :type="shareType"
                    :userName="userName"
                    :phone="phone"
                />
            </div>
            <div class="custom-share-content">
                <p class="tip-txt">复制链接或下载公司卡片分享给他人，打开链接或图片后可查看客户信息</p>
                <p class="share-company">{{ shareCustomerName }}</p>
                <p class="share-link">{{ copyLink }}</p>
                <div class="share-btns">
                    <el-button type="primary" plain @click="handleClickCopyImg">下载公司卡片</el-button>
                    <el-button type="primary" @click="handleClickCopyUrl">复制链接</el-button>
                </div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import { ShareCustomer } from "@/api";
import CustomerCompanyCard from "./customer_company_card.vue";
import html2canvas from "html2canvas";
export default {
    name: "CustomerShareDialog",
    components: { CustomerCompanyCard },
    props: {
        shareDialog: {
            type: Boolean,
            default: false,
        },
        shareCustomerId: "",
        shareCustomerName: {
            type: String,
            default: "",
        },
        shareType: {
            type: Number,
            default: 1, // 1-公海，2-私海
        },
    },
    data() {
        return {
            copyLink: "",
            userName: "",
            phone: "",
        };
    },
    created() {
        const name =
            this.$store.state.userInfo && this.$store.state.userInfo.user && this.$store.state.userInfo.user.name;
        this.userName = name;
        const phone =
            this.$store.state.userInfo && this.$store.state.userInfo.user && this.$store.state.userInfo.user.phone;
        this.phone = phone.substr(-4);
        this.getCopyLink();
    },
    methods: {
        handleDialogClose() {
            this.$refs.customerCompanyCard && this.$refs.customerCompanyCard.clearWatemark();
            this.$emit("update:shareDialog", false);
        },
        getCopyLink() {
            const domain = window.location.protocol + "//" + window.location.host;
            const textToCopy = `${domain}/#/customer/share?customer_id=${this.shareCustomerId}&type=${this.shareType}&name=${this.userName}&phone=${this.phone}`;
            this.copyLink = textToCopy;
        },
        async handleClickCopyImg() {
            ShareCustomer({customer_id: this.shareCustomerId}).then(res=> {
                if(res.code === 200) {
                    
                }
            })
            let Dom = document.querySelector("#qrcodeOutBox");
            let DomChild = document.querySelector("#companyWatermark");
            // 会出现连续在当前弹框下载的时候 元素其实已经被删除
            let divElement = document.createElement("div");
            divElement.appendChild(DomChild);

            // 会出现水印不显示的问题
            // let divElement = DomChild.cloneNode(true)
            Dom.appendChild(divElement);
            // const canvas = await html2canvas(document.querySelector('#qrcodeOutBox'), { allowTaint: false, useCORS: true,height: document.scrollHeight,windowHeight: document.scrollHeight });
            const canvas = await html2canvas(divElement, {
                allowTaint: true,
                useCORS: true,
                height: document.scrollHeight,
                windowHeight: document.scrollHeight,
            });
            if (canvas) {
                const url = canvas.toDataURL("image/png").replace(/^data:image\/[^;]/, "data:application/octet-stream");
                var link = document.createElement("a");
                link.download = "公司卡片.png"; // 下载的文件名
                link.href = url;
                link.click();
                Dom.removeChild(divElement);
            }
        },
        handleClickCopyUrl() {
            ShareCustomer({customer_id: this.shareCustomerId}).then(res=> {
                if(res.code === 200) {
                    
                }
            })
            const textToCopy = this.copyLink;
            const textarea = document.createElement("textarea");
            textarea.value = textToCopy;
            document.body.appendChild(textarea);
            // 选中文本并复制
            textarea.select();
            document.execCommand("copy");
            // 移除临时元素
            document.body.removeChild(textarea);
            this.$message.success("已成功复制！");
        },
    },
};
</script>
<style lang="scss">
.custom-share-dialog {
    .custom-share-dialog-wrap {
        position: relative;
        width: 100%;
        height: 280px;
        overflow: hidden;
    }

    #qrcodeOutBox {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 280px;
        z-index: 0;
    }

    .custom-share-content {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 280px;
        background-color: #ffffff;
        z-index: 100;

        .tip-txt {
            padding: 8px 9px;
            border-radius: 4px;
            background: #edf0f4;
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(102, 102, 102, 1);
            text-align: center;
        }

        .share-company {
            margin-top: 36px;
            font-size: 18px;
            font-weight: 700;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(51, 51, 51, 1);
            text-align: center;
        }

        .share-link {
            margin-top: 16px;
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(41, 144, 255, 1);
            text-align: center;
        }

        .share-btns {
            margin-top: 77px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 24px;

            .el-button {
                width: 144px;
                height: 40px;
                padding: 0;
                text-align: center;
                line-height: 40px;
            }
        }
    }
}
</style>
